<template>
  <div class="d-flex flex-column mx-4 py-4" :style="'background-color:#FFFFFF;  border-radius: 0 0 30px 30px;'">
    <div class="text-center w-100">
      <h4 class="font-weight-bold mt-5" style="color:#092C4C">{{ queue.languageSelect === 0 ? queue.flowNameTh : queue.flowNameEn  }}</h4>
    </div>
    <div class="text-center w-100">
      <h4 class="font-weight-bold" style="color:#092C4C">{{ queue.languageSelect === 0 ? "หมายเลขคิวของคุณ" : "Your Number" }}</h4>
    </div>
    <div class="text-center w-100">
      <p style="color:#092C4C;font-size: 80px;" class="text-center font-weight-black mt-n5 mb-n5"> {{ queue.queueNumber }}</p>
    </div>
    <div class="text-center d-flex justify-content-center w-100 px-5" v-if="queue.status === 'confirm'">
      <div v-if="queue.previousQueue > 0" class="d-flex flex-row align-items-center">
        <div  >
          <h5 style="color:#092C4C" class="text-center font-weight-bold mt-2">
        {{ queue.languageSelect === 0 ? `มีคิวก่อนหน้าคุณ ` : `There are ` }}
         </h5>
        </div>
        <div class="mx-2">
          <v-avatar color="#092C4C"  class="mx-auto mt-2" size="35">
      <span style="color:#fff">{{ queue.previousQueue }}</span>
    </v-avatar>
        </div>
        <div >
          <h5 style="color:#092C4C" class="text-center font-weight-bold mt-2">
        {{ queue.languageSelect === 0 ? `คิว` : `before you.` }} </h5>
        </div>
        <!-- <h5 style="color:#092C4C" class="text-center font-weight-bold mt-2">
        {{ queue.languageSelect === 0 ? `มีคิวก่อนหน้าคุณ ${queue.previousQueue} คิว` : `There are ${queue.previousQueue} queues ahead of you.` }}
      </h5> -->
      </div>
      <div  class="text-center w-100 px-5" v-else>
        <h5 style="color:#092C4C" class="text-center font-weight-bold mt-2">{{ queue.languageSelect === 0 ? "ตอนนี้คุณอยู่คิวแรกแล้ว" : "You are now in the first queue."  }}</h5>
        <h5 style="color:#092C4C" class="text-center font-weight-bold mt-2">{{ queue.languageSelect === 0 ? "กรุณารอเจ้าหน้าที่เรียกคิว" : "Please wait for the staff to call the queue." }}</h5>
      </div>
    </div>
    <div class="text-center w-100 px-5" v-else-if="queue.status === 'confirmJob'">
      <h5 style="color:#092C4C" class="text-center font-weight-bold mt-2">{{ queue.languageSelect === 0 ? "ถึงคิวของคุณแล้ว" : "Your queue has been called." }}</h5>
      <h5 style="color:#092C4C" class="text-center font-weight-bold">{{ queue.languageSelect === 0 ? `ช่องบริการที่ ${queue.counter}` : `Counter ${queue.counter}` }}</h5>
    </div>
    <div class="text-center w-100 px-5" v-else-if="queue.status === 'closeJob'">
      <h5 style="color:#092C4C" class="text-center font-weight-bold mt-2">{{ queue.languageSelect === 0 ? "ขอบคุณที่ใช้บริการ OH! RiCH" : "Thanks, OH! RiCH" }}</h5>
    </div>
    <div class="text-center w-100 px-5" v-else>
      <h5 style="color:#092C4C" class="text-center font-weight-bold mt-2">
        <h5 style="color:#092C4C" class="text-center font-weight-bold mt-2">{{ queue.languageSelect === 0 ? "คิวของคุณถูกเรียกไปแล้ว" : "Your queue has been called."  }}</h5>
        <h5 style="color:#092C4C" class="text-center font-weight-bold mt-2">{{ queue.languageSelect === 0 ? "กรุณากดรับบัตรคิวใหม่" : "Please press to receive a new queue card." }}</h5>
      </h5>
    </div>
    <div class="d-flex flex-row justify-content-between  w-100 px-5 mt-2">
      <div>
        <p style="color:#092C4C">{{ queue.languageSelect === 0 ? "วันที่เข้าบริการ" : "Service date" }}</p>
      </div>
      <div>
        <p >{{ queue.dueDate }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    queue: {
      type: Object,
      required: true,
      default: () => ({
        shopName: '',
        flowNameTh: '',
        flowNameEn: '',
        dueDate: '',
        counter: '',
        previousQueue: 0,
        queueNumber: '',
        status: '',
        languageSelect: 0
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OhRich/QueueSheet.vue